import { useEffect, useState } from 'react';
import { Navigate, Outlet, useParams } from 'react-router';
import { setCurrentQuery } from '../applicationSlice';
import { defaultAllOpenQuery, isActiveQuery } from '@api/Trinium/Endpoints/BoardQueries/types';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import { useFetchBoardQuery } from '@api/Trinium/Endpoints/BoardQueries/slice';
import CompanyProgressBar from '../Components/Loading/CompanyProgressBar';
import { useAppDispatch } from '@reduxStore';

/**
 * Component responsible for handling and maintaining the current Board Query based on the URL.
 */
export default function BoardQueryProxy() {
	const { query: urlBoardQuery } = useParams();
	const appDispatch = useAppDispatch();
	const [invalidQuery, setInvalidQuery] = useState(false);
	const { number: terminalNumber } = useCurrentTerminal();
	const { data: queries, isLoading } = useFetchBoardQuery(terminalNumber);

	/**  */
	useEffect(() => {
		if (!isLoading) {
			if (urlBoardQuery) {
				/** Validate this query is available for the user */
				if (queries && queries.find((x) => x.name === urlBoardQuery && isActiveQuery(x))) {
					appDispatch(setCurrentQuery(urlBoardQuery));
				} else {
					setInvalidQuery(true);
				}
			} else {
				// If there is no Board Query URL param, use the default or defaultAllOpenQuery query
				const defaultQuery = queries && queries.find((x) => x.isDefault && isActiveQuery(x));
				appDispatch(setCurrentQuery(defaultQuery ? defaultQuery.name : defaultAllOpenQuery.name));
			}
		}
	}, [urlBoardQuery, appDispatch, isLoading, queries]);

	/** If it was an invalid query, redirect the user back to /Board */
	if (invalidQuery) {
		return <Navigate to={'..'} />;
	}

	if (isLoading) {
		return <CompanyProgressBar />;
	}

	return <Outlet />;
}
